import { useState } from "react";
import { AppClient, appLogos, appNames } from "./appClients";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import getClaudeDesktopInstructions from "./instructions/claude_desktop";
import MarkdownContainer from "../../../shared/markdown/MarkdownContainer";
import getRaycastInstructions from "./instructions/raycast_instructions";
import getClaudeCodeInstructions from "./instructions/claude_code";
import getGeminiCliInstructions from "./instructions/gemini_cli_instructions";
import getVsCodeInstructions from "./instructions/vs_code_mcp";
import {
  getCursorInstructions1,
  getCursorInstructions2,
} from "./instructions/cursor_mcp";
import { buildCursorDeeplink } from "./instructions/cursor_mcp";
import getClineInstructions from "./instructions/cline_mcp";
import getBoltAiInstructions from "./instructions/boltai_mcp";
import getAmazonQInstructions from "./instructions/amazon_q_mcp";

const AppItem = ({ app, playground, uiMode, bearerToken, mcpServerUrl }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="app_item">
      {/* Expanded state drives a class rather than an inline style: the divider
          colour has to differ per uiMode, and inline styles can't be themed. */}
      <div
        className={`app_header${expanded ? " expanded" : ""}`}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="left_side">
          <div className="app_logo">{appLogos[uiMode][AppClient[app]]}</div>
          <div className="app_name">{appNames[AppClient[app]]}</div>
        </div>
        <div className="right_side">
          {expanded && <ChevronUpIcon />}
          {!expanded && <ChevronDownIcon />}
        </div>
      </div>
      {expanded && (
        <div className="app_instructions">
          {AppClient[app] === AppClient.CLAUDE_DESKTOP && (
            <MarkdownContainer>
              {getClaudeDesktopInstructions(
                playground,
                bearerToken,
                mcpServerUrl
              )}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.CLAUDE_CODE && (
            <MarkdownContainer>
              {getClaudeCodeInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.GEMINI_CLI && (
            <MarkdownContainer>
              {getGeminiCliInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.RAYCAST && (
            <MarkdownContainer>
              {getRaycastInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.VS_CODE && (
            <MarkdownContainer>
              {getVsCodeInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.CURSOR && (
            <>
              <MarkdownContainer>
                {getCursorInstructions1(playground, bearerToken, mcpServerUrl)}
              </MarkdownContainer>
              <a
                href={`${buildCursorDeeplink(
                  playground,
                  bearerToken,
                  mcpServerUrl
                )}`}
                class="cursor-deeplink"
              >
                👉 Add to Cursor
              </a>
              <p></p>
              <MarkdownContainer>
                {getCursorInstructions2(playground, bearerToken, mcpServerUrl)}
              </MarkdownContainer>
            </>
          )}
          {AppClient[app] === AppClient.CLINE && (
            <MarkdownContainer>
              {getClineInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.BOLTAI && (
            <MarkdownContainer>
              {getBoltAiInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
          {AppClient[app] === AppClient.AMAZON_Q && (
            <MarkdownContainer>
              {getAmazonQInstructions(playground, bearerToken, mcpServerUrl)}
            </MarkdownContainer>
          )}
        </div>
      )}
    </div>
  );
};

export default AppItem;
